/** @format */

import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/Logo.png";
export default function Footer() {
  return (
    <footer className=" sticky  dark:bg-dark-800 dark:text-white min-h-80  w-full overflow-hidden text-left sm:text-center bg-gray-50 shadow-inner mt-10 p-2 md:p-5">
      {/* <p className="text-2xl font-serif h-12 font-semibold">Trending Anime</p> */}
      <div className=" flex flex-col md:flex-row w-96 text-xs sm:text-sm sm:w-[38rem] gap-5  text-center m-auto mt-5 ">
        <p>Site rules</p>
        <Link to="/termsAndConditions">Terms and conditions</Link>
        <Link to="/privacyPolicy">Privacy Policy</Link>
        <Link to="/about">About us</Link>
        <Link to="/contact">Contact us</Link>
        <p>Advertise with us</p>
      </div>

      <div className="flex flex-col sm:px-7 m-auto gap-1   flex-wrap">
        {" "}
        <img
          src={Logo}
          className="m-auto mt-5 h-16 sm:mt-5 w-56 object-cover"
          alt="trending anime"
        />
        <p className="m-auto  pb-4 text-sm font-serif text-center font-bold mt-5">
          Trending Anime © 2021. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
